import { GlobalState } from '../../reducers';
import { ImageInjectionState } from './reducers';

const imageInjectionPopoverSelector = (
  store: GlobalState,
): ImageInjectionState => (
  store.apps.manual.imageInjection
);

export default {
  imageInjectionPopoverSelector,
};
